import IListFilter from "@/models/IListFilter";
import StringHelper from "@/helpers/StringHelper";
import {CategoryState, CategoryView} from "@/helpers/constants";

export default class CategoryListFilter implements IListFilter {

	public fulltext: string | null = null;
	public isRoot: boolean | null = null;
	public name: string | null = null;
	public externalId: string | null = null;
	public states: CategoryState[] = [];
	public views: CategoryView[] = [];
	public isTopCategory: boolean | null = null;
	public sortIndex: number | null = null;
	public showItems: boolean | null = null;
	public clampDescription: boolean | null = null;
	public hasFrameAssembly: boolean | null = null;
	public defaultSortBy: string[] = [];

	public clear(): void {
		this.fulltext = null;
		this.isRoot = null;
		this.name = null;
		this.states = [];
		this.views = [];
		this.isTopCategory = null;
		this.sortIndex = null;
		this.showItems = null;
		this.clampDescription = null;
		this.hasFrameAssembly = null;
		this.defaultSortBy = [];
	}

	public hasFilter(): boolean {
		if (this.states !== null && this.states.length > 0) {
			return true;
		}

		if (this.views !== null && this.views.length > 0) {
			return true;
		}

		return !StringHelper.allEmpty([this.fulltext, this.name, this.externalId])
			|| this.isRoot !== null;
	}

}
